import React from "react";
import { useMediaQuery } from "usehooks-ts";
import styled from "styled-components";
import { getDisplayTagLabel, tagsGuide } from "@/utils/cms.utils";

export { getDisplayTagLabel, tagsGuide };

const tagImageGuide = {
  TURKISH_NATIVE: {
    large: "/tags/turkish-native-large.svg",
    small: "/tags/turkish-native-small.svg",
    sportClassName:
      "lg:w-[126px] md:w-[120px] bg-[#B21F1F] w-[87px] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[100px] bg-none shadow-none",
    episodeClassName:
      "w-[120px] md:w-[92px] lg:w-[100px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    className:
      "w-[60%] md:w-[92px] lg:w-[100px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
  TURKISH_REPORT: {
    large: "/tags/gozaresh-large.svg",
    small: "/tags/gozaresh-small.svg",
    sportClassName: "w-[100px] md:w-[120px] bg-none shadow-none",
    animationClassName: "w-[58px] md:w-[62px] lg:w-[66px] bg-none shadow-none",
    episodeClassName: "w-[90px] md:w-[85px] lg:w-[100px] bg-none shadow-none",
    className: "w-[90px] md:w-[85px] lg:w-[100px] bg-none shadow-none",
  },
  LIVE_STREAM: {
    large: "/tags/live-stream-large.svg",
    small: null,
    sportClassName: "w-[120px] lg:w-[160px] md:w-[120px] bg-none shadow-none",
    animationClassName: "w-[80px] md:w-[95px] lg:w-[100px] bg-none shadow-none",
    episodeClassName: "w-[120px] md:w-[120px] lg:w-[140px] bg-none shadow-none",
    className: "w-[160px] lg:w-[160px] md:w-[120px] bg-none shadow-none",
  },
  COMING_SOON: {
    large: "/tags/coming-soon-large.svg",
    small: null,
    sportClassName:
      "lg:w-[80px] md:w-[120px] bg-[#B21F1F] w-[87px] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[60%] md:w-[90px] lg:w-[76px] bg-none shadow-none",
    episodeClassName:
      "w-[87px] md:w-[92px] lg:w-[75px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    className:
      "w-[60%] md:w-[92px] lg:w-[75px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
  ONLINE_CINEMA: {
    large: "/tags/online-cinema-large.svg",
    small: "/tags/online-cinema-small.svg",
    sportClassName:
      "lg:w-[138px] md:w-[120px] bg-[#B21F1F] w-[100px] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[60%] md:w-[93px] lg:w-[90px] bg-none shadow-none",
    episodeClassName:
      "w-[100px] md:w-[92px] lg:w-[95px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    className:
      "w-[60%] md:w-[92px] lg:w-[95px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
  ARCHIVE: {
    large: "/tags/archive-large.svg",
    small: null,
    sportClassName:
      "lg:w-[80px] md:w-[110px] bg-[#B21F1F] w-[87px] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[68px] md:w-[90px] lg:w-[70px] bg-none shadow-none",
    episodeClassName:
      "w-[87px] md:w-[92px] lg:w-[70px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    className:
      "w-[60%] md:w-[92px] lg:w-[70px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
};

const TagContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  font-size: 0.875rem;
  overflow: hidden;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
  @media (min-width: 1280px) {
    font-size: 1.25rem;
  }
  z-index: 20;
  align-items: center;
  text-align: center;
  border-radius: 0;
  border-bottom-left-radius: 2rem;
  position: absolute;
  top: -1px;
  right: -1px;
  left: 0;
  color: white;
  padding-bottom: 10px;
  padding-left: 10px;
  pointer-events: none;
`;

const TagImage = styled.img`
  display: block;
  height: auto;
  max-width: 100%;
  flex-shrink: 0;
  border-radius: 0 0 0 12px;
`;

const ContentTag = ({ label, type, tags }) => {
  const isMD = useMediaQuery("(min-width: 768px)");
  const displayLabel = getDisplayTagLabel(label, tags);
  const tagCode = tagsGuide[displayLabel];
  if (!tagCode) return null;

  const tagImage = tagImageGuide[tagCode];

  const tagImageSrc =
    !isMD && tagImage?.small !== null ? tagImage?.small : tagImage?.large;

  return (
    <TagContainer type={type}>
      {type === "sport" ? (
        <TagImage
          src={tagImageSrc}
          alt={displayLabel}
          className={tagImage.sportClassName}
        />
      ) : type === "animation" ? (
        <TagImage
          src={tagImageSrc}
          alt={displayLabel}
          className={tagImage.animationClassName}
        />
      ) : type === "episode" ? (
        <TagImage
          src={tagImageSrc}
          alt={displayLabel}
          className={tagImage.episodeClassName}
        />
      ) : (
        <TagImage
          src={tagImageSrc}
          alt={displayLabel}
          className={tagImage.className}
        />
      )}
    </TagContainer>
  );
};

export default ContentTag;
